// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-not-found_root__mvKi6"};